import React, { useState } from 'react';
import { api } from "../../services/api";
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import ModalImportacao from "./ModalImportacao";
import { Modal, Spinner } from 'react-bootstrap';
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaFileExcel } from "react-icons/fa";
import {
    FaStore,
    FaPercent,
    FaMoneyBillWave,
    FaLaptop,
    FaCopy,
    FaBalanceScale
} from "react-icons/fa";

export default function ConciliacaoCartao() {

    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lista, setLista] = useState([]);

    const [totais, setTotais] = useState({
        bruto: 0,
        taxa: 0,
        liquido: 0,
        software: 0,
        duplicidade: 0,
        liquido_duplicidade: 0,
        duplicidade_se: 0
    });
    // =========================
    // EXPORTAR EXCEL — GOD MODE
    // =========================
    const handleExportExcel = () => {
        if (!lista || lista.length === 0) {
            Swal.fire("Aviso", "Não há dados para exportar.", "warning");
            return;
        }

        try {
            // =========================
            // MONTA DADOS DINÂMICOS
            // =========================
            const dadosExcel = lista.map(row => ({
                ...(filtros.checkLoja && { Loja: row.loja }),
                ...(filtros.checkVenda && {
                    "Data Venda": formatarDataParaBR(row.datavenda)
                }),
                ...(filtros.checkRoteamento && { Roteamento: row.roteamento }),
                ...(filtros.checkBandeira && { Bandeira: row.bandeira }),
                Bruto: Number(row.valorbruto || 0),
                "Taxa (%)": Number(row.taxa || 0),
                "Valor Taxa": Number(row.valortaxa || 0),
                Liquido: Number(row.valorliq || 0)
            }));

            // =========================
            // PLANILHA PRINCIPAL
            // =========================
            const ws = XLSX.utils.json_to_sheet(dadosExcel);

            const range = XLSX.utils.decode_range(ws["!ref"]);

            // 🔒 congelar primeira linha
            ws["!freeze"] = { xSplit: 0, ySplit: 1 };

            // 🔽 auto filtro
            ws["!autofilter"] = { ref: ws["!ref"] };

            // 📏 largura automática
            ws["!cols"] = Object.keys(dadosExcel[0]).map(() => ({ wch: 18 }));

            // =========================
            // FORMATA NÚMEROS
            // =========================
            for (let R = 1; R <= range.e.r; ++R) {
                Object.keys(dadosExcel[0]).forEach((colName, C) => {
                    const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                    const cell = ws[cellAddress];

                    if (!cell) return;

                    if (
                        colName.includes("Bruto") ||
                        colName.includes("Taxa") ||
                        colName.includes("Liquido")
                    ) {
                        cell.t = "n";
                        cell.z = "#,##0.00";
                    }
                });
            }

            // =========================
            // LINHA DE TOTAIS
            // =========================
            const totalBruto = lista.reduce((s, r) => s + Number(r.valorbruto || 0), 0);
            const totalTaxa = lista.reduce((s, r) => s + Number(r.valortaxa || 0), 0);
            const totalLiquido = lista.reduce((s, r) => s + Number(r.valorliq || 0), 0);

            const linhaTotal = {};

            Object.keys(dadosExcel[0]).forEach(col => {
                if (col === "Bruto") linhaTotal[col] = totalBruto;
                else if (col === "Valor Taxa") linhaTotal[col] = totalTaxa;
                else if (col === "Liquido") linhaTotal[col] = totalLiquido;
                else linhaTotal[col] = "";
            });

            XLSX.utils.sheet_add_json(ws, [linhaTotal], {
                skipHeader: true,
                origin: -1
            });

            // =========================
            // ABA RESUMO (BI)
            // =========================
            const diferenca = calcularDiferenca();

            const resumoData = [
                { Indicador: "Período", Valor: `${filtros.dataInicio} a ${filtros.dataFim}` },
                { Indicador: "Total Bruto", Valor: totais.bruto },
                { Indicador: "Total Taxa", Valor: totais.taxa },
                { Indicador: "Total Líquido", Valor: totais.liquido },
                { Indicador: "Software", Valor: totais.software },
                { Indicador: "Duplicidade", Valor: totais.duplicidade },
                { Indicador: "Diferença", Valor: diferenca }
            ];

            const wsResumo = XLSX.utils.json_to_sheet(resumoData);
            wsResumo["!cols"] = [{ wch: 28 }, { wch: 22 }];

            // =========================
            // WORKBOOK
            // =========================
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, wsResumo, "Resumo");
            XLSX.utils.book_append_sheet(wb, ws, "Conciliacao");

            // =========================
            // GERAR ARQUIVO
            // =========================
            const excelBuffer = XLSX.write(wb, {
                bookType: "xlsx",
                type: "array",
                compression: true
            });

            const data = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const nomeArquivo =
                `Conciliacao_GOD_${filtros.dataInicio}_${filtros.dataFim}.xlsx`;

            saveAs(data, nomeArquivo);

            Swal.fire("Sucesso", "Excel gerado com sucesso!", "success");

        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Falha ao exportar Excel.", "error");
        }
    };
    // =========================
    // DATAS PADRÃO
    // =========================

    const agora = new Date();
    const hoje = agora.toISOString().split('T')[0];
    const primeiroDiaDoMes = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        1
    ).toISOString().split('T')[0];

    const [filtros, setFiltros] = useState({
        dataInicio: primeiroDiaDoMes,
        dataFim: hoje,
        checkLoja: true,
        checkVenda: true,
        checkRoteamento: false,
        checkBandeira: false,
        checkCondicao: false,
        checkCredito: false
    });

    // =========================
    // FORMATADORES
    // =========================

    const formatarMoeda = (valor) =>
        new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(Number(valor || 0));

    const formatarDataParaBR = (dataIso) => {
        if (!dataIso) return '';
        try {
            const limpa = dataIso.replace('Z', '');
            const d = new Date(limpa);
            if (isNaN(d)) return dataIso;
            return d.toLocaleDateString('pt-BR');
        } catch {
            return dataIso;
        }
    };

    const formatarDataFiltro = (dataIso) => {
        if (!dataIso) return '';
        const [ano, mes, dia] = dataIso.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    // =========================
    // DIFERENÇA (IGUAL DELPHI)
    // =========================

    const calcularDiferenca = () => {
        const liquido = Number(totais.liquido || 0);
        const liquidoDup = Number(totais.liquido_duplicidade || 0);
        const software = Number(totais.software || 0);
        const duplSe = Number(totais.duplicidade_se || 0);

        return ((liquido - liquidoDup) - software) - duplSe;
    };

    // =========================
    // CONSULTA
    // =========================

    const handleConsultar = async () => {

        const algumMarcado =
            filtros.checkLoja ||
            filtros.checkVenda ||
            filtros.checkRoteamento ||
            filtros.checkBandeira ||
            filtros.checkCondicao ||
            filtros.checkCredito;

        if (!algumMarcado) {
            Swal.fire("Erro", "Selecione ao menos um agrupamento.", "error");
            return;
        }

        setLoading(true);

        try {
            const params = {
                ...filtros,
                dataInicio: formatarDataFiltro(filtros.dataInicio),
                dataFim: formatarDataFiltro(filtros.dataFim)
            };

            const res = await api.get('/financeiro/conciliacao', { params });

            setLista(res.data?.dados || []);
            setTotais(res.data?.resumo || {});
        } catch (err) {
            Swal.fire("Erro", "Falha ao consultar dados", "error");
        } finally {
            setTimeout(() => setLoading(false), 400);
        }
    };

    // =========================
    // RENDER
    // =========================

    return (
        <div className="bg-light min-vh-100">

            <Menu modulo="FINANCEIRO" />

            {/* LOADING */}
            <Modal show={loading} centered backdrop="static" keyboard={false} size="sm">
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" variant="primary" className="mb-2" />
                    <div className="fw-bold">Consultando dados...</div>
                    <small className="text-muted">Aguarde um momento</small>
                </Modal.Body>
            </Modal>

            {/* MAIN */}
            <main
                className="container-fluid"
                style={{
                    paddingTop: '95px',
                    position: 'relative',
                    zIndex: 1
                }}
            >

                {/* ================= FILTROS ================= */}
                <div className="card shadow-sm border-0 mb-3">
                    <div className="card-body py-2">

                        <div className="row g-2 align-items-end">

                            <div className="col-md-auto">
                                <label className="form-label small fw-bold mb-0">Data Início</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={filtros.dataInicio}
                                    onChange={e => setFiltros({ ...filtros, dataInicio: e.target.value })}
                                />
                            </div>

                            <div className="col-md-auto">
                                <label className="form-label small fw-bold mb-0">Data Fim</label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={filtros.dataFim}
                                    onChange={e => setFiltros({ ...filtros, dataFim: e.target.value })}
                                />
                            </div>

                            <div className="col">
                                <label className="form-label small fw-bold mb-1">Agrupar por</label>

                                <div className="d-flex flex-wrap gap-2">
                                    {['Loja', 'Venda', 'Roteamento', 'Bandeira', 'Condicao', 'Credito'].map(f => (
                                        <div key={f}>
                                            <input
                                                type="checkbox"
                                                className="btn-check"
                                                id={`chk${f}`}
                                                checked={filtros[`check${f}`]}
                                                onChange={e =>
                                                    setFiltros({
                                                        ...filtros,
                                                        [`check${f}`]: e.target.checked
                                                    })
                                                }
                                            />
                                            <label
                                                htmlFor={`chk${f}`}
                                                className="btn btn-outline-secondary btn-sm py-1 px-2"
                                                style={{ fontSize: '0.75rem' }}
                                            >
                                                {f}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="col-md-auto d-flex gap-2">
                                <button
                                    className="btn btn-primary btn-sm fw-bold px-3"
                                    onClick={handleConsultar}
                                >
                                    PESQUISAR
                                </button>

                                <button
                                    className="btn btn-success btn-sm fw-bold px-3"
                                    onClick={() => setShowModal(true)}
                                >
                                    IMPORTAR
                                </button>

                                <button
                                    className="btn btn-outline-success btn-sm fw-bold px-3 d-flex align-items-center gap-2"
                                    onClick={handleExportExcel}
                                >
                                    <FaFileExcel />
                                    EXCEL
                                </button>
                            </div>

                        </div>
                    </div>
                </div>

                {/* ================= TABELA ================= */}
                <div className="card shadow-sm border-0 mb-2">
                    <div className="table-responsive" style={{ maxHeight: '50vh' }}>
                        <table className="table table-sm table-hover table-bordered mb-0">
                            <thead className="table-dark sticky-top text-center">
                                <tr>
                                    {filtros.checkLoja && <th>Loja</th>}
                                    {filtros.checkVenda && <th>Data Venda</th>}
                                    {filtros.checkRoteamento && <th>Roteamento</th>}
                                    {filtros.checkBandeira && <th>Bandeira</th>}
                                    <th>Bruto</th>
                                    <th>Taxa (%)</th>
                                    <th>Vlr. Taxa</th>
                                    <th>Líquido</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    [...Array(6)].map((_, i) => (
                                        <tr key={i}>
                                            <td colSpan="10" className="py-2">
                                                <div className="placeholder-glow">
                                                    <span className="placeholder col-12"></span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : lista.length === 0 ? (
                                    <tr>
                                        <td colSpan="10" className="text-center py-3 text-muted">
                                            Nenhum dado consultado.
                                        </td>
                                    </tr>
                                ) : (
                                    lista.map((row, i) => (
                                        <tr key={i} className="text-center align-middle">
                                            {filtros.checkLoja && <td>{row.loja}</td>}
                                            {filtros.checkVenda && <td>{formatarDataParaBR(row.datavenda)}</td>}
                                            {filtros.checkRoteamento && <td className="text-start ps-3">{row.roteamento}</td>}
                                            {filtros.checkBandeira && <td>{row.bandeira}</td>}
                                            <td className="text-end fw-bold">{formatarMoeda(row.valorbruto)}</td>
                                            <td>{row.taxa?.toFixed(2)}%</td>
                                            <td className="text-end text-danger">{formatarMoeda(row.valortaxa)}</td>
                                            <td className="text-end fw-bold text-primary">{formatarMoeda(row.valorliq)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* ================= TOTAIS ================= */}
                <div className="sticky-bottom bg-light pt-2 pb-2 border-top">
                    <div className="row g-2">

                        <CardTotal icon={<FaMoneyBillWave />} label="BRUTO" value={totais.bruto} bg="primary" />
                        <CardTotal icon={<FaPercent />} label="TAXA" value={totais.taxa} bg="danger" />
                        <CardTotal icon={<FaStore />} label="LÍQUIDO" value={totais.liquido} bg="success" />
                        <CardTotal icon={<FaLaptop />} label="SOFTWARE" value={totais.software} bg="warning" />
                        <CardTotal icon={<FaCopy />} label="DUPLICIDADE" value={totais.duplicidade} bg="secondary" />

                        <CardTotal
                            icon={<FaBalanceScale />}
                            label="DIFERENÇA"
                            value={calcularDiferenca()}
                            bg={calcularDiferenca() === 0 ? "info" : "dark"}
                            highlight={calcularDiferenca() !== 0}
                        />

                    </div>
                </div>

            </main>

            <ModalImportacao show={showModal} onHide={() => setShowModal(false)} />
            <Footer />
        </div>
    );
}

// ================= CARD =================

function CardTotal({ label, value, bg, icon, highlight }) {

    const formatarMoeda = (valor) =>
        new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor || 0);

    return (
        <div className="col-6 col-md">
            <div
                className={`card border-0 shadow-sm bg-${bg} text-white h-100`}
                style={{
                    borderRadius: '12px',
                    transform: highlight ? 'scale(1.03)' : 'scale(1)',
                    transition: 'all .25s ease'
                }}
            >
                <div className="card-body p-2">

                    <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
                        <div style={{ fontSize: '0.9rem' }}>{icon}</div>
                        <div style={{ fontSize: '0.70rem', fontWeight: 700 }}>
                            {label}
                        </div>
                    </div>

                    <div
                        className="text-center"
                        style={{
                            fontSize: '1.15rem',
                            fontWeight: 900
                        }}
                    >
                        {formatarMoeda(value)}
                    </div>

                    {highlight && (
                        <div className="text-center mt-1">
                            <small style={{ fontSize: '0.65rem', opacity: 0.9 }}>
                                ⚠ Divergência detectada
                            </small>
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}